import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppState } from '@core/store';
import { selectQuantityLimitErrorModal } from '@core/store/cart';
import { QuantityLimitErrorData } from '@core/store/cart/cart-state-models';
import * as cartActions from '@core/store/cart/cart.actions';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-quantity-limit-error-modal',
  templateUrl: './quantity-limit-error-modal.component.html',
  styleUrls: ['./quantity-limit-error-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuantityLimitErrorModalComponent implements OnInit {
  data$: Observable<QuantityLimitErrorData | null> = this.store$.select(
    selectQuantityLimitErrorModal,
  );

  constructor(
    private store$: Store<AppState>,
    private router: Router,
  ) {}

  currentData: QuantityLimitErrorData | null = null;

  ngOnInit(): void {
    this.data$.subscribe((data) => {
      this.currentData = data;
    });
  }
  close(): void {
    this.store$.dispatch(cartActions.resetQuantityLimitErrorModal());
  }
}
